import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import "./Router.css";

import { Provider } from "react-redux";
import store from "./store";
import Instructor_ID from "./actions/InstructorIDService";
import App from "./App";
import InstructorDashboard from "./components/instructor/InstructorDashboard";
import InstructorDayView from "./components/instructor/InstructorDayView";
import NotFound from "./components/core/NotFound";
import Header from "./components/layout/Header";
import Sidebar from "./components/layout/Sidebar";

class MainRouter extends React.Component {
  render() {
    if (!Instructor_ID) {
      window.location.replace("https://www.brooklyndrives.com");
      return <h2>Unable to find ID. Please log in or contact office. </h2>;
    }
    return (
      <Provider store={store}>
        <Router>
          <div className="container-fluid">
            <div className="row">
              <Header />
              <Sidebar />
              <main className="main-content">
                <Switch>
                  <Route
                    exact
                    path="/app/instructor-dashboard"
                    component={App}
                  />
                  <Route
                    path="/app/instructor-dashboard/:day/:sid"
                    component={InstructorDashboard}
                  />
                  <Route
                    path="/app/instructor-dashboard/:day"
                    component={InstructorDayView}
                  />
                  <Route>
                    <Redirect to="/app/instructor-dashboard" />
                  </Route>
                  <Route component={NotFound} />
                </Switch>
              </main>
            </div>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default MainRouter;
